module.exports = __webpack_public_path__ + "img/BE0400067788.7530e4bc.png";